import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import styles from './FirstView.module.css';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const FirstView = () => {
  const wrapperRef = useRef(null);
  const [slots, setSlots] = useState(null);

  // 10から99までのランダムな数値を生成する関数
  const generateRandomSlots = () => Math.floor(Math.random() * (99 - 10 + 1)) + 10;

  useEffect(() => {
    // コンポーネントのマウント時にランダムな数値でslots状態を更新
    setSlots(generateRandomSlots());

    // 24時間ごとにslots状態を更新するインターバルを設定
    const intervalId = setInterval(() => {
      setSlots(generateRandomSlots());
    }, 24 * 60 * 60 * 1000); // 24時間をミリ秒で

    // コンポーネントのアンマウント時にインターバルをクリア
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const { current: wrapper } = wrapperRef;
    const boxes = wrapper.children;
    gsap.to(boxes, {
      rotation: "+=360",
      repeat: -1,  // 無限に繰り返し
      ease: "none",
      duration: 3,
      transformOrigin: "center center",
    });
  }, []);
  return (
    <section className={styles.fv_area}>
      <div>
        <h2>3営業日<br className="sp"/>ランディングページ</h2>
        <p>
            緊急のランディングページ制作をお手伝いいたします。
        </p>
        <div className={styles.count}>
            <span><AccessTimeIcon />現在の受付残枠数：2件</span>
            <div className={styles.num_wrapper} ref={wrapperRef}>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
      </div>
    </section>
  )
}

export default FirstView